<template>
  <div :class="`notice--${noticeType}`" class="notice pl-8 p-4 shadow-md rounded-sm text-left">
    <slot />
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      noticeType?: string
    }>(),
    {
      noticeType: 'hint',
    },
  )
</script>

<style scoped lang="scss">
  .notice {
    position: relative;
    &:before {
      content: '';
      position: absolute;
      display: inline-block;
      background-size: contain;
      top: -16px;
      left: -16px;
      width: 48px;
      height: 48px;
    }
    &--hint {
      background: #bae6fd;
      color: #0369a1;
      &:before {
        background: url('@/images/icons/hint.png');
        background-size: 48px 48px;
      }
    }
    &--alert {
      background: #fecaca;
      color: #b91c1c;
      &:before {
        background: url('@/images/icons/alert.png');
        background-size: 48px 48px;
      }
    }
  }
</style>
